module.exports = __webpack_public_path__ + "img/联系ta.1c831324.svg";